import { render, staticRenderFns } from "./ServiceList.vue?vue&type=template&id=d63ca7be&scoped=true"
import script from "./ServiceList.vue?vue&type=script&lang=js"
export * from "./ServiceList.vue?vue&type=script&lang=js"
import style0 from "./ServiceList.vue?vue&type=style&index=0&id=d63ca7be&prod&lang=css"
import style1 from "./ServiceList.vue?vue&type=style&index=1&id=d63ca7be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63ca7be",
  null
  
)

export default component.exports